export const ADMIN = 'ADMIN';
export const ORGANISATION = 'ORG' ;
export const USER = 'USER'; 
export const MANAGER = 'MANAGER'; 
export const SUPERADMIN = 'SUPERADMIN'; 
